module.exports = __webpack_public_path__ + "img/users_grey.116f0b72.svg";